window.customElements.define(
  "mega-menu",
  class Megamenu extends HTMLElement {
    megamenuCurrentClass = "megamenu--current";
    megamenuVisibleClass = "megamenu--isVisible";
    megamenuAnimateClass = "megamenu--animate";
    searchModalClass = ".section-header .header__search details";
    bodyClass = "megamenu--isActive";
    megamenuElClass = '[id^="shopify-section-sections"] #megamenu';
    mainNavTarget = "header .header__menu-item.megamenu-item";
    curtainTarget = "mega-menu-curtain";
    megamenuEl = null;
    timer = null;
    menuLinkHoverDuration = 100;

    constructor() {
      super();
    }

    connectedCallback() {
      this.addCurtain();
      this.addMeganavToHeader();

      // Event listeners
      this.windowEventScroll();
      this.linkEventMouseover();
      this.curtainEventClick();
      this.linkEventMouseout();
      this.linkEventKeyPress();
      this.curtainEventMouseover();
      this.megamenuEventMouseLeave();
    }

    disconnectedCallback() {
      if (this.megamenuEl) this.megamenuEl.remove();
    }

    // Methods
    addCurtain() {
      if (document.getElementById("megamenu")) return;
      this.innerHTML = "<mega-menu-curtain></mega-menu-curtain>" + this.innerHTML;
    }

    addMeganavToHeader() {
      document.querySelector('[id^="shopify-section-sections"] .header-wrapper').insertAdjacentHTML("afterend", this.innerHTML);
      this.innerHTML = "";
      this.megamenuEl = document.querySelector(this.megamenuElClass);
    }

    removeAnimation() {
      this.megamenuEl.classList.remove(this.megamenuAnimateClass);
      document.body.classList.remove(this.bodyClass);
    }

    showMegamenuItem(menuItemEl) {
      if (!menuItemEl) return;

      let megamenuId = "megamenu-" + window.handleize(menuItemEl.innerText);
      let megamenuItemEl = document.getElementById(megamenuId);

      if (!megamenuItemEl) {
        this.hideAllMenuItems();
        this.removeAnimation();
        clearTimeout(this.timer);
        return;
      }

      // hide search modal
      this.hideSearchModal();

      let timerHoverDuration = this.menuIsVisible() ? 0 : this.menuLinkHoverDuration;

      let self = this;
      this.timer = setTimeout(function () {
        // prepare menu for animation
        document.body.classList.add(self.bodyClass);
        self.megamenuEl.classList.add(self.megamenuAnimateClass);

        // show mega menu item
        setTimeout(function () {
          self.hideAllMenuItems();
          menuItemEl.classList.add(self.megamenuCurrentClass);
          megamenuItemEl.classList.add(self.megamenuVisibleClass);
        }, timerHoverDuration);
      }, timerHoverDuration);
    }

    hideAllMenuItems() {
      // hide mega menu item
      let currentMenuItems = document.querySelectorAll("." + this.megamenuCurrentClass);

      if (currentMenuItems) {
        for (var i = 0; i < currentMenuItems.length; i++) {
          let currentMenuItem = currentMenuItems[i];
          currentMenuItem.classList.remove(this.megamenuCurrentClass);
        }
      }

      let visibleMenuItems = document.querySelectorAll("." + this.megamenuVisibleClass);

      if (visibleMenuItems) {
        for (var i = 0; i < visibleMenuItems.length; i++) {
          let visibleMenuItem = visibleMenuItems[i];
          visibleMenuItem.classList.remove(this.megamenuVisibleClass);
        }
      }

      let detailsOpen = document.querySelectorAll(this.megamenuElClass + " details[open]");
      if (detailsOpen) {
        for (var i = 0; i < detailsOpen.length; i++) {
          let detailOpen = detailsOpen[i];
          detailOpen.removeAttribute("open");
        }
      }
    }

    hideSearchModal() {
      const searchModal = document.querySelector(this.searchModalClass);
      if (searchModal && searchModal.hasAttribute("open")) searchModal.removeAttribute("open");
    }

    menuIsVisible() {
      return document.querySelector("#megamenu.megamenu--animate") ? true : false;
    }

    // Event Listeners
    curtainEventClick() {
      const self = this;
      document.addEventListener("click", function (e) {
        if (!e.target.closest(self.curtainTarget)) return false;
        self.hideAllMenuItems();
        self.removeAnimation();
      });
    }

    curtainEventMouseover() {
      const self = this;
      document.addEventListener("mouseover", function (e) {
        if (!e.target.closest(self.curtainTarget)) return false;
        if (!self.menuIsVisible()) return;

        clearTimeout(self.timer);
        self.hideAllMenuItems();
        self.removeAnimation();
      });
    }

    windowEventScroll() {
      const self = this;
      window.addEventListener("scroll", function (e) {
        self.hideAllMenuItems();
        self.removeAnimation();
      });
    }

    linkEventMouseover() {
      const self = this;
      document.addEventListener("mouseover", function (e) {
        if (!e.target.closest(self.mainNavTarget)) return false;
        self.showMegamenuItem(e.target);
      });
    }

    linkEventMouseout() {
      const self = this;
      document.addEventListener("mouseout", function (e) {
        if (!e.target.closest(self.mainNavTarget)) return false;
        clearTimeout(self.timer);
      });
    }

    megamenuEventMouseLeave() {
      const self = this;
      window.addEventListener("mouseout", function (event) {
        if (event.clientY <= 0 || event.clientX <= 0 || event.clientX >= window.innerWidth || event.clientY >= window.innerHeight) {
          self.hideAllMenuItems();
        }
      });
    }

    linkEventKeyPress() {
      const self = this;

      document.addEventListener("keydown", function (e) {
        if (!e.target.closest(self.mainNavTarget)) return false;
        if (e.code === "Enter" || e.code === "Space") self.showMegamenuItem(e.target);
        if (e.code === "Escape") self.hideAllMenuItems();
      });
    }
  }
);
